export enum RouteKeys {
  List = '/role',
  New = '/role/new',
  Edit = '/role/:id',
}
